import { render, staticRenderFns } from "./Socio-edit.vue?vue&type=template&id=110c7fd5"
import script from "./Socio-edit.vue?vue&type=script&lang=js"
export * from "./Socio-edit.vue?vue&type=script&lang=js"
import style0 from "./Socio-edit.vue?vue&type=style&index=0&id=110c7fd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../.yarn/__virtual__/vue-loader-virtual-2b047b6fb3/8/home/ilcomi/.yarn/berry/cache/vue-loader-npm-15.11.1-829412283a-10c0.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports